// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dKip","label":"styles_label__1Ja43"};